import script from "./DialogSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogSidebar.vue?vue&type=script&setup=true&lang=js"

import "./DialogSidebar.vue?vue&type=style&index=0&id=d135fbc2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d135fbc2"]])

export default __exports__